import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export default function Wysiwyg(props: {
    product: Queries.ProductsJson;
    className?: string;
}) {
    const { product, className = '' } = props;
    const { currentLocale } = usePageLocalization();

    if (product?.attributes?.content_wysiwyg) {
        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{
                    __html: product?.attributes?.content_wysiwyg?.values?.[0]?.[
                        currentLocale
                    ] as string,
                }}
            />
        );
    } else if (product?.fields?.contentMarkdown?.[currentLocale]) {
        return (
            <div
                className={className}
                dangerouslySetInnerHTML={{
                    __html: product?.fields?.contentMarkdown?.[
                        currentLocale
                    ] as string,
                }}
            />
        );
    } else
        return (
            <span className={className}>
                {product?.attributes?.content?.values?.[0]?.[currentLocale]}
            </span>
        );
}
